import React, { useState, useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import YouTube from "react-youtube";

import logo from "./logo.svg";
import "./App.css";

function App() {
    const particlesInit = useCallback(async (engine) => {
        // Use loadSlim instead of loadFull to avoid compatibility issues
        await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback((container) => {
        console.log("Particles container loaded", container);
    }, []);

    const [email, setEmail] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState("Email");

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage("Sending...");

        try {
            const response = await fetch(
                "https://bot.kuroshio.ai/email_signup/",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email }),
                }
            );

            if (response.ok) {
                setSubmitMessage("Thank you!");
                setEmail("");
            } else {
                setSubmitMessage("Something went wrong");
            }
        } catch (error) {
            console.error("Error submitting email:", error);
            setSubmitMessage("Network error");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="App">
            <header className="App-header">
                <div className="logo-container">
                    <img src={logo} className="App-logo" alt="logo" />
                    <h1>Outperform VR</h1>
                </div>
            </header>

            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{
                    fpsLimit: 60,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                        },
                        modes: {
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 100,
                                duration: 0.9,
                            },
                        },
                    },
                    particles: {
                        number: {
                            value: 30,
                            density: {
                                enable: true,
                                value_area: 800,
                            },
                        },
                        color: {
                            value: "#ffffff",
                        },
                        shape: {
                            type: "circle",
                        },
                        opacity: {
                            value: 0.5,
                        },
                        size: {
                            value: 3,
                        },
                        links: {
                            enable: true,
                            distance: 150,
                            color: "#ffffff",
                            opacity: 0.4,
                            width: 1,
                        },
                        move: {
                            enable: true,
                            speed: 0.8,
                            direction: "none",
                            random: false,
                            straight: false,
                            outModes: {
                                default: "out",
                            },
                        },
                    },
                    detectRetina: true,
                }}
            />

            <section className="email-signup" id="vr-background">
                <form onSubmit={handleSubmit}>
                    <input
                        type="email"
                        placeholder={submitMessage}
                        className="email-input"
                        value={email}
                        onChange={handleEmailChange}
                        required
                        disabled={isSubmitting}
                    />
                    <button type="submit" disabled={isSubmitting}>
                        Join the waiting list!
                    </button>
                </form>

                <div className="mission-statement">
                    <h2>Mission Statement</h2>
                    <p>
                        Outperform VR empowers artists and musicians to save
                        time, <br /> cut costs, and conquer stage anxiety with
                        immersive VR simulations and AI-driven feedback.
                        <br />
                        We transform rehearsal into mastery, helping artists
                        perform with confidence, <br />
                        control, and peak execution—without expensive venues or
                        wasted hours.
                    </p>
                </div>
            </section>

            {/* <section className="video-section">
                <YouTube
                    videoId="6Ke9ueftbkw"
                    opts={{
                        playerVars: {
                            autoplay: 1,
                        },
                    }}
                />
            </section> */}

            <section className="vision-statement-block">
                <div className="vision-statement">
                    <h2>Vision Statement</h2>
                    <p>
                        We envision a world where artists and musicians perform
                        fearlessly,
                        <br />
                        anytime, anywhere, with full control over their
                        progress.
                        <br />
                        By 2030, Outperform VR will be the #1 performance
                        training platform,
                        <br />
                        revolutionizing rehearsal through VR, AI, and real-world
                        simulation.
                    </p>
                </div>
            </section>

            <section className="team-members">
                <h2>Meet Our Team</h2>
                <div className="team-members">
                    <div
                        className="team-member"
                        onClick={() =>
                            window.open(
                                "https://www.linkedin.com/in/ivanianov/",
                                "_blank",
                                "noopener noreferrer"
                            )
                        }
                        style={{ cursor: "pointer" }}
                    >
                        <div className="image-wrapper">
                            <img src="./ivan_ianov.jpeg" alt="Team Member 1" />
                        </div>
                        <h3>Ivan Ianov</h3>
                        <p>Chief Executive Officer</p>
                        <a
                            href="https://www.linkedin.com/in/ivanianov/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src="./linkedin.png" alt="LinkedIn" />
                        </a>
                    </div>

                    <div
                        className="team-member"
                        onClick={() =>
                            window.open(
                                "https://linkedin.com/in/kartamyshev",
                                "_blank",
                                "noopener noreferrer"
                            )
                        }
                        style={{ cursor: "pointer" }}
                    >
                        <div className="image-wrapper">
                            <img
                                src="./vlad_kartamyshev.jpeg"
                                alt="Team Member 2"
                            />
                        </div>
                        <h3>Vlad Kartamyshev</h3>
                        <p>Chief Technology Officer</p>
                        <a
                            href="https://linkedin.com/in/kartamyshev"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src="./linkedin.png" alt="LinkedIn" />
                        </a>
                    </div>
                </div>

                <div className="contact-button-wrapper">
                    <a
                        href="mailto:yanovbusiness@gmail.com"
                        className="contact-button"
                    >
                        Contact Us
                    </a>
                </div>
            </section>
        </div>
    );
}

export default App;
